import {z} from 'zod';

import {base64ImageSchema} from '../common/Base64ImageSchema';

export const scanLicensePlateRequestSchema = z.object({
  imageBase64: base64ImageSchema,
});

export type ScanLicensePlateRequest = z.infer<typeof scanLicensePlateRequestSchema>;
